import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0bb78cae = () => interopDefault(import('../_templates/pages/blog/Blog.vue' /* webpackChunkName: "" */))
const _50c7ca6f = () => interopDefault(import('../pages/checkout/Cart.vue' /* webpackChunkName: "" */))
const _17ea2fae = () => interopDefault(import('../_templates/pages/checkout/Checkout.vue' /* webpackChunkName: "" */))
const _5017a934 = () => interopDefault(import('../pages/checkout/Checkout/Order.vue' /* webpackChunkName: "" */))
const _85032ca8 = () => interopDefault(import('../_templates/pages/checkout/Checkout/Account.vue' /* webpackChunkName: "" */))
const _f4a19334 = () => interopDefault(import('../_templates/pages/checkout/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _82c7281a = () => interopDefault(import('../_templates/pages/customer/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _b288ab3e = () => interopDefault(import('../_templates/pages/customer/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _5fc376c6 = () => interopDefault(import('../_templates/pages/customer/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _309311a1 = () => interopDefault(import('../_templates/pages/customer/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _b670e826 = () => interopDefault(import('../_templates/pages/customer/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _042f028d = () => interopDefault(import('../_templates/pages/customer/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _da527a9c = () => interopDefault(import('../_templates/pages/customer/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _1a8d21dc = () => interopDefault(import('../_templates/pages/faq/Faq.vue' /* webpackChunkName: "" */))
const _89d6da14 = () => interopDefault(import('../_templates/pages/theme/Home.vue' /* webpackChunkName: "" */))
const _073842e4 = () => interopDefault(import('../_templates/pages/wishlist/Wishlist.vue' /* webpackChunkName: "" */))
const _0d30d72e = () => interopDefault(import('../_templates/pages/search/Search.vue' /* webpackChunkName: "" */))
const _4ea1abce = () => interopDefault(import('../_templates/pages/payment-svea/Checkout.vue' /* webpackChunkName: "" */))
const _34b9f6c8 = () => interopDefault(import('../_templates/pages/customer/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _57818eba = () => interopDefault(import('../_templates/pages/payment-svea/CheckoutConfirmation.vue' /* webpackChunkName: "" */))
const _6dc23e6e = () => interopDefault(import('../_templates/pages/blog/BlogPost.vue' /* webpackChunkName: "" */))
const _e0ded86a = () => interopDefault(import('../_templates/pages/attribute-collection/AttributeCollection.vue' /* webpackChunkName: "" */))
const _4b2e4004 = () => interopDefault(import('../_templates/pages/attribute-collection/AttributeCollectionItem.vue' /* webpackChunkName: "" */))
const _0b49a8a6 = () => interopDefault(import('../_templates/pages/theme/Page.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aktuelt",
    component: _0bb78cae,
    name: "blog___nb_NO___default"
  }, {
    path: "/cart",
    component: _50c7ca6f,
    name: "checkout-cart___nb_NO___default"
  }, {
    path: "/checkout",
    component: _17ea2fae,
    name: "checkout___nb_NO___default",
    children: [{
      path: "bestilling",
      component: _5017a934,
      name: "checkout-order___nb_NO___default"
    }, {
      path: "konto",
      component: _85032ca8,
      name: "checkout-account___nb_NO___default"
    }, {
      path: "takk",
      component: _f4a19334,
      name: "checkout-thank-you___nb_NO___default"
    }]
  }, {
    path: "/customer",
    component: _82c7281a,
    meta: {"titleLabel":"Account"},
    name: "customer___nb_NO___default",
    children: [{
      path: "addresses-details",
      component: _b288ab3e,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___nb_NO___default"
    }, {
      path: "my-profile",
      component: _5fc376c6,
      meta: {"titleLabel":"My Account"},
      name: "customer-my-profile___nb_NO___default"
    }, {
      path: "order-history",
      component: _309311a1,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___nb_NO___default"
    }, {
      path: "addresses-details/create",
      component: _b670e826,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___nb_NO___default"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _042f028d,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___nb_NO___default"
    }, {
      path: "order-history/:orderId",
      component: _da527a9c,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___nb_NO___default"
    }]
  }, {
    path: "/faq.html",
    component: _1a8d21dc,
    name: "faq___nb_NO___default"
  }, {
    path: "/nb_NO",
    component: _89d6da14,
    name: "home___nb_NO"
  }, {
    path: "/onskeliste",
    component: _073842e4,
    name: "wishlist___nb_NO___default"
  }, {
    path: "/search",
    component: _0d30d72e,
    name: "search___nb_NO___default"
  }, {
    path: "/sveacheckout",
    component: _4ea1abce,
    name: "sveaCheckout___nb_NO___default"
  }, {
    path: "/checkout/Cart",
    component: _50c7ca6f,
    name: "checkout-Cart___nb_NO___default"
  }, {
    path: "/customer/reset-password",
    component: _34b9f6c8,
    alias: "/customer/account/createPassword",
    name: "reset-password___nb_NO___default"
  }, {
    path: "/nb_NO/aktuelt",
    component: _0bb78cae,
    name: "blog___nb_NO"
  }, {
    path: "/nb_NO/cart",
    component: _50c7ca6f,
    name: "checkout-cart___nb_NO"
  }, {
    path: "/nb_NO/checkout",
    component: _17ea2fae,
    name: "checkout___nb_NO",
    children: [{
      path: "bestilling",
      component: _5017a934,
      name: "checkout-order___nb_NO"
    }, {
      path: "konto",
      component: _85032ca8,
      name: "checkout-account___nb_NO"
    }, {
      path: "takk",
      component: _f4a19334,
      name: "checkout-thank-you___nb_NO"
    }]
  }, {
    path: "/nb_NO/customer",
    component: _82c7281a,
    meta: {"titleLabel":"Account"},
    name: "customer___nb_NO",
    children: [{
      path: "addresses-details",
      component: _b288ab3e,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___nb_NO"
    }, {
      path: "my-profile",
      component: _5fc376c6,
      meta: {"titleLabel":"My Account"},
      name: "customer-my-profile___nb_NO"
    }, {
      path: "order-history",
      component: _309311a1,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___nb_NO"
    }, {
      path: "addresses-details/create",
      component: _b670e826,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___nb_NO"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _042f028d,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___nb_NO"
    }, {
      path: "order-history/:orderId",
      component: _da527a9c,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___nb_NO"
    }]
  }, {
    path: "/nb_NO/faq.html",
    component: _1a8d21dc,
    name: "faq___nb_NO"
  }, {
    path: "/nb_NO/onskeliste",
    component: _073842e4,
    name: "wishlist___nb_NO"
  }, {
    path: "/nb_NO/search",
    component: _0d30d72e,
    name: "search___nb_NO"
  }, {
    path: "/nb_NO/sveacheckout",
    component: _4ea1abce,
    name: "sveaCheckout___nb_NO"
  }, {
    path: "/sveacheckout/confirmation",
    component: _57818eba,
    name: "sveaCheckoutConfirmation___nb_NO___default"
  }, {
    path: "/checkout/Checkout/Order",
    component: _5017a934,
    name: "checkout-Checkout-Order___nb_NO___default"
  }, {
    path: "/nb_NO/checkout/Cart",
    component: _50c7ca6f,
    name: "checkout-Cart___nb_NO"
  }, {
    path: "/nb_NO/customer/reset-password",
    component: _34b9f6c8,
    alias: "/customer/account/createPassword",
    name: "reset-password___nb_NO"
  }, {
    path: "/nb_NO/sveacheckout/confirmation",
    component: _57818eba,
    name: "sveaCheckoutConfirmation___nb_NO"
  }, {
    path: "/nb_NO/checkout/Checkout/Order",
    component: _5017a934,
    name: "checkout-Checkout-Order___nb_NO"
  }, {
    path: "/nb_NO/aktuelt/:slug+",
    component: _6dc23e6e,
    name: "blogPost___nb_NO"
  }, {
    path: "/nb_NO/collection/:slug([^/.]+).html",
    component: _e0ded86a,
    name: "attributeCollection___nb_NO"
  }, {
    path: "/nb_NO/collection/:collection_slug/:slug+.html",
    component: _4b2e4004,
    name: "attributeCollectionItem___nb_NO"
  }, {
    path: "/aktuelt/:slug+",
    component: _6dc23e6e,
    name: "blogPost___nb_NO___default"
  }, {
    path: "/nb_NO/:slug+",
    component: _0b49a8a6,
    name: "page___nb_NO"
  }, {
    path: "/collection/:slug([^/.]+).html",
    component: _e0ded86a,
    name: "attributeCollection___nb_NO___default"
  }, {
    path: "/collection/:collection_slug/:slug+.html",
    component: _4b2e4004,
    name: "attributeCollectionItem___nb_NO___default"
  }, {
    path: "/",
    component: _89d6da14,
    name: "home___nb_NO___default"
  }, {
    path: "/:slug+",
    component: _0b49a8a6,
    name: "page___nb_NO___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
